import { render, staticRenderFns } from "./userGuideStore2.vue?vue&type=template&id=104657b2&scoped=true"
import script from "./userGuideStore2.vue?vue&type=script&lang=js"
export * from "./userGuideStore2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104657b2",
  null
  
)

export default component.exports